import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import BaseMixer from "@/router/views/BaseMixer";
import { ClockWorkModule } from "@/store/modules/clockWork.module";
import { interpret } from "xstate";
import clockWorkMiniMachine from "./machines/clockworkMiniMachines";
import { bus } from "@/main";
let ClockWorkMini = /** @class */ (() => {
    let ClockWorkMini = class ClockWorkMini extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.showSep = false;
            this.currentDate = new Date();
            this.machine = clockWorkMiniMachine.withContext({
                currentDate: new Date(),
            });
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        addEntry() {
            this.machineService.send({ type: "START" });
        }
        stopEntry() {
            this.machineService.send({ type: "STOP", liveEntry: this.cwMiniEntry });
        }
        goToRunningState() {
            this.machineService.send({ type: "RUNNING_STATE" });
        }
        UpdateCwMiniEntryDescription() {
            ClockWorkModule.UpdateCwMiniEntry(this.cwMiniEntry).then((response) => { });
        }
        getFormattedDateString(value) {
            return `${value.getFullYear()}-${value.getMonth() + 1}-${value.getDate()}T00:00:00`;
        }
        NavigateToClockWork() {
            this.$router.push({ name: "ClockWork" });
        }
        get cwMiniEntry() {
            return ClockWorkModule.cwMiniEntry;
        }
        get entry() {
            return ClockWorkModule.cwMiniEntry ?? { description: "" };
        }
        get inputTextWidthCWMini() {
            return this.cwMiniEntry && this.cwMiniEntry.description.length > 14 ? this.cwMiniEntry.description.length * 8 : 120;
        }
        created() {
            bus.$on("cw_mini_running_state", this.goToRunningState);
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (this.state.matches("starting")) {
                    this.setFocusToInputAndSelect("clock-work-mini-text");
                }
            });
            this.machineService.start();
        }
        destroyed() {
            this.machineService.stop();
            bus.$off("cw_mini_running_state", this.goToRunningState);
        }
    };
    ClockWorkMini = __decorate([
        Component({
            name: "ClockWorkMini",
        })
    ], ClockWorkMini);
    return ClockWorkMini;
})();
export default ClockWorkMini;
